import React from 'react';
import './services.css'
import Image1 from '../../assets/services.svg'
import Image2 from '../../assets/service-2.svg'
import Image3 from '../../assets/service-1.svg'

const data = [
  {
    id: 1,
    image: Image1,
    title: "Frontend Development",
    description:
      "Designing responsive, user-friendly, and visually appealing interfaces to ensure seamless experiences across all devices.",
  },
  {
    id: 2,
    image: Image2,
    title: "Backend Development",
    description:
      "Creating secure, scalable, and efficient server-side solutions that power your applications with reliability and speed.",
  },
  {
    id: 3,
    image: Image3,
    title: "UI/UX Design",
    description:
      "Crafting intuitive and engaging designs focused on user experience, making every interaction meaningful and enjoyable.",
  },
];


const Services = () => {
  return (
    <section className="services container section" id='services'>
      <h2 className="section__title">Services</h2>

      <div className="services__container grid">
        {data.map(({id, image, title, description}) => {
          return (
            <div className="services__card" key={id}>
              <img src={image} alt="" className="services__img" />

              <h3 className="services__title">{title}</h3>
              <p className="services__description">{description}</p>
            </div>
          );
        })}
      </div>
    </section>
  )
}

export default Services